import * as angular from "angular";


angular
  .module('bringoz.admin')
  .provider('browserPrint', browserPrintProvider);

/* @ngInject */
function browserPrintProvider(): any {

  this.initScript = () => {
    // var browser_print_script = document.createElement('script');
    // browser_print_script.setAttribute('src','static/BrowserPrint-3.0.125-P2.min.js');
    // document.body.appendChild(browser_print_script);
  };

  this.$get = () => {
    return {
      initScript: this.initScript
    };
  };
}
